'use strict';


export class AllBlocks {
  constructor() {
    $('a').on('click', function (e) {
      var href = $(this).attr('href');
      var hostname = window.location.hostname;
      if (href.indexOf('http') == -1 && href.indexOf(hostname) == -1) {
        // do nothing / default behaviour
      } else {
        // force link to open in new tab / window
        e.preventDefault();
        window.open(href, '_blank');
      }
    });    
    
    // wrap table in div table
    (function() {
      $(".views-table").wrapAll("<div class='view-table'></div>");
    })();
  }
}
